<template>
  <el-dialog
    class="reput_detail"
    :close-on-click-modal="false"
    :visible.sync="show"
    width="1000px"
    append-to-body>
    <p slot="title" class="dialog_title">复投结果</p>
    <div class="i_search">
      <el-input
        type="text"
        size="small"
        placeholder="查找小区"
        v-model="nbhdName"
        ref="search"
        @focus.once="addKeyupEvent">
        <i
          class="iconfont icon-dingdanxiangqing-sousuo search_btn"
          slot="suffix"
          @click="getDetailList(1)">
        </i>
      </el-input>
    </div>
    <el-table
      class="point_table"
      ref="pointTable"
      size="mini"
      height="350"
      border
      stripe
      :data="nbhdList"
      :empty-text="isSearch ? '暂无结果，换个名称重新试试吧~' : '暂无数据'"
      @filter-change="filterChange">
      <el-table-column prop="nbhdGuid" label="小区编码" align="center" width="80"></el-table-column>
      <el-table-column prop="name" label="小区名称" align="center" min-width="120"></el-table-column>
      <!-- <el-table-column prop="location" label="小区地址" align="center" min-width="150"></el-table-column> -->
      <el-table-column prop="address" label="行政区" align="center" min-width="80"></el-table-column>
      <el-table-column prop="equipModel" label="设备类型" align="center" width="120"></el-table-column>
      <el-table-column prop="equipNo" label="设备编码" align="center" min-width="170"></el-table-column>
      <el-table-column prop="equipName" label="设备名称" align="center" min-width="140"></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        column-key="status"
        :filters="statusFilters"
        :filter-method="filterMethod"
        width="100">
      </el-table-column>
    </el-table>
    <Pagination
      class="page_box"
      :autoLoad="false"
      :total="pageInfo.total"
      :current-page.sync="pageInfo.pageIndex"
      :size.sync="pageInfo.pageSize"
      @fn-change="getDetailList">
    </Pagination>
    <div slot="footer" class="i_footer">
      <el-button
        class="btn import_btn"
        type="primary"
        size="mini"
        :disabled="!nbhdList || nbhdList.length === 0"
        @click="exportDetailExcel">
        导出
      </el-button>
      <el-button type="default" size="mini" class="btn close_btn" @click="show = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Pagination from '@/components/Pagination'
import { getWifiPutDetail, exportWifiReputDetail } from '@/utils/api'

export default {
  name: 'ReputDetail',
  components: { Pagination },
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    orderCode: {
      type: String,
      default: ''
    },
    uuid: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      nbhdName: '',
      nbhdList: [],
      pageInfo: {
        total: 0,
        pageIndex: 1,
        pageSize: 10
      },
      statusFilters: [{
        text: '选点成功',
        value: '选点成功'
      }, {
        text: '无WiFi',
        value: '无WiFi'
      }, {
        text: '不可投',
        value: '不可投'
      }],
      filterOpts: []
    }
  },
  computed: {
    show: {
      get () {
        return this.visible
      },
      set (nv) {
        this.$emit('update:visible', nv)
      }
    },
    isSearch () {
      return !!this.nbhdName.trim()
    }
  },
  watch: {
    visible (nv) {
      if (!nv) {
        this.nbhdName = ''
        this.filterOpts = []
        return
      }
      this.$refs.pointTable && this.$refs.pointTable.clearFilter()
      this.getDetailList(1)
    },
    nbhdName (nv) {
      if (!nv.trim()) {
        this.getDetailList(1)
      }
    }
  },
  methods: {
    async getDetailList (p) {
      if (p) this.pageInfo.pageIndex = p
      this.nbhdList = []
      let res = await getWifiPutDetail({
        orderCode: this.orderCode,
        nbhdName: this.nbhdName,
        pageIndex: this.pageInfo.pageIndex,
        pageSize: this.pageInfo.pageSize,
        statusList: this.filterOpts,
        h5: this.isH5RealTime,
        uuid: this.uuid
      })
      this.nbhdList = []
      if (res.code === 0) {
        this.$nextTick(() => {
          this.nbhdList = res.data.list
          this.pageInfo.total = res.data.total || 0
        })
      } else {
        this.pageInfo.total = 0
      }
    },
    async exportDetailExcel () {
      await exportWifiReputDetail({
        orderCode: this.orderCode,
        nbhdName: this.nbhdName,
        statusList: this.filterOpts,
        h5: this.isH5RealTime,
        uuid: this.uuid
      })
      this.show = false
    },
    filterMethod (value, row, column) {
      return row.status === value
    },
    filterChange (filters) {
      this.filterOpts = filters.status
      // let list = this.nbhdList
      // this.nbhdList = []
      // this.$nextTick(() => {
      //   this.nbhdList = list
      // })
      this.pageInfo = { pageIndex: 1, pageSize: 10, total: 0 }
      this.getDetailList()
    },
    addKeyupEvent () {
      this.$refs.search.$el.addEventListener('keyup', e => {
        if (e.code === 'Enter') {
          this.getDetailList(1)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.reput_detail {
  ::v-deep .el-dialog__header {
    padding: 12px 10px;
    box-shadow: 0 1px 0 0 #e9e9e9;
    .el-dialog__headerbtn {
      top: 16px;
    }
  }
  ::v-deep .el-dialog__body {
    padding: 20px 19px;
  }
  ::v-deep .el-dialog__footer {
    box-shadow: 0 -1px 0 0 #e9e9e9;
  }
}
.dialog_title {
  text-align: center;
  color: #282729;
  font-size: 18px;
  line-height: 25px;
}
.i_search {
  width: 240px;
  margin: 0 auto 10px;
  text-align: center;
  ::v-deep .el-input__inner {
    padding-left: 20px;
    border-radius: 15px;
  }
  ::v-deep .el-input__suffix {
    right: 20px;
    .iconfont {
      font-size: 18px;
    }
  }
}
.point_table {
  box-sizing: content-box;
}
.page_box {
  height: 60px;
  padding: 6px 10px 6px 20px;
  border-left: 1px solid #E9E9E9;
  border-right: 1px solid #E9E9E9;
  border-bottom: 1px solid #E9E9E9;
}
.i_footer {
  text-align: center;
  .btn {
    width: 120px;
  }
  .import_btn {
    padding: 8px 15px;
    background: linear-gradient(315deg, rgba(255, 132, 109, 1) 0%, rgba(255, 57, 115, 1) 100%);
    border: none;
  }
}
.search_btn {
  line-height: 32px;
  cursor: pointer;
}
.close_btn:hover {
  color: #FF3973 !important;
  background-color: rgba(#FF3973, .1) !important;
  border-color: #FF3973 !important;
}
</style>
